import React, { createContext, forwardRef, FunctionComponent, useContext } from 'react'

import { PLUGIN_CONFIGS } from '@plugins/mappings'
import PluginSlot from '@plugins/Slot'

export const usePluginContext = () => useContext(PluginContext)

export const defaultPlugin: Plugin.Config = { code: null, components: {}, hooks: {} }
export type PluginContextValue = Omit<Plugin.Config, 'code'> & { plugin: Plugin.Config; abTests: ABTests.Config[] }
export const defaultPluginContextValue: PluginContextValue = {
  ...defaultPlugin,
  plugin: defaultPlugin,
  abTests: [],
}
export const PluginContext = createContext<PluginContextValue>(defaultPluginContextValue)

export const mergeChanges = (config: Plugin.Config, ...abTests: ABTests.Config[]) =>
  abTests.reduce(
    (acc, curr) => ({
      ...acc,
      ...curr,
      components: { ...acc.components, ...curr.components },
      hooks: { ...acc.hooks, ...curr.hooks },
      callbacks: { ...acc.callbacks, ...curr.callbacks },
    }),
    config,
  ) as Plugin.Config

export const definePlugin = (code: string, config: Partial<Exclude<Plugin.Config, 'code'>>) => ({
  ...defaultPlugin,
  code,
  ...config,
})

export const withPluginSlot = <Props = {},>(Component: FunctionComponent<Props>, key: string) => {
  return forwardRef(function SlotWrapper(props: Props, ref) {
    return <PluginSlot path={key} FallbackComponent={Component} props={{ ...props, ref }} />
  })
}

export const getPluginPath = (retailerNumber: number, carrierCode?: string | null): string | undefined => {
  if (!carrierCode) return PLUGIN_CONFIGS[`${retailerNumber}`]

  return (
    PLUGIN_CONFIGS[`${retailerNumber}-${carrierCode}`] ?? PLUGIN_CONFIGS[carrierCode] ?? PLUGIN_CONFIGS[retailerNumber]
  )
}
